/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import config from "../configs/sys32config";

const GET_RECEIVER_PHONE_ID = `${config.spring_url_base}customer/get_by_phone`;
const GET_RECEIVER_PHONE_LIKE = `${config.spring_url_base}customer/phones_like`;
const GET_OR_CREATE_CUSTOMER_PHONE = `${config.spring_url_base}customer/get_or_create`;
const GET_RECEIVER_PHONE_BY_VALUE = `${config.spring_url_base}customer/phones_by_value`;
const GET_RECEIVER_PHONE_BY_RECEIVER = `${config.spring_url_base}customer/phones_by_customer`;
const GET_PROVINCES = `${config.spring_url_base}other/select_province`;
const GET_RECEIVER_ADDRESS_BY_RECEIVER = `${config.spring_url_base}customer/address_by_customer`;
const CREATE_RECEIVER_BY_PHONE = `${config.spring_url_base}customer/create_by_phone`;
const CREATE_RECEIVER_ADDRESS = `${config.spring_url_base}customer/address/create`;

const UPDATE_RECEIVER_NAME = `${config.spring_url_base}customer/update_name`;

const GET_SENDERS = `${config.spring_url_base}merchant/is_member`;
const GET_SENDERS_USING_INVENTORY = `${config.spring_url_base}merchant/is_using_inventory`;
//TODO
const GET_SENDERS_FOR_INVOICE = `${config.spring_url_base}merchant/invoice_selector`;

const GET_RECYCLE_LOG_BY_DELIVERYORDER = `${config.spring_url_base}recycle_log/by_delivery_order?sort=createdAt,DESC`;
const CREATE_RECYCLE_LOG = `${config.spring_url_base}recycle_log`;

const CREATE_PACKAGE_REQUEST_BY_ORDER = `${config.spring_url_base}delivery_order/package_request/create`;
const ADD_ITEM_INTO_PACKAGE_REQUEST = `${config.spring_url_base}delivery_order/package_request/add_inventory_item`;
const DELETE_PACKAGE_REQUEST_ITEM = `${config.spring_url_base}delivery_order/package_request/remove_inventory_item`;
const ADJUST_PACKAGE_REQUEST_QTY = `${config.spring_url_base}delivery_order/package_request/adjust_qty`;

const GET_DELIVERYORDER_BY_ID = `${config.spring_url_base}delivery_order/by_id`;
const CREATE_DELIVERYORDER = `${config.spring_url_base}delivery_order`;
const CREATE_DELIVERY_SHEET = `${config.spring_url_base}delivery_order/sheet/create`;
const DELETE_DELIVERY_SHEET = `${config.spring_url_base}delivery_sheet/delete`;
const UPDATE_DELIVERYORDER = `${config.spring_url_base}delivery_order`;
const REASSIGN_SHEET = `${config.spring_url_base}delivery_sheet/reassign_sheet`;
const CHECK_ORDER_IMPORT_FILE_NAME = `${config.spring_url_base}delivery_order/check_import_file_name`;

const GET_DELIVERY_ORDER = `${config.spring_url_base}delivery_order`;
const GET_DELIVERY_ORDER_LIST = `${config.spring_url_base}delivery_order/list`;
const GET_DELIVERYORDER_PACKAGE_REQUEST = `${config.spring_url_base}delivery_order/package_request`;
const GET_DELIVERY_4_EXPORT_STATUS = `${config.spring_url_base}delivery_order/get_4_export_status`;

const CONFIRM_DELIVERY_SHEET = `${config.spring_url_base}delivery_sheet/confirm`;
const CONFIRM_DELIVERY_SHEET_BATCH = `${config.spring_url_base}delivery_sheet/confirm/batch`;

const GET_INVENTORY_BY_SENDER = `${config.spring_url_base}inventory/by_merchant`;
const GET_SHEET_BY_DELIVERY_ORDER_ID = `${config.spring_url_base}delivery_order/find_sheet`;
const GET_RECEIVER_PHONE_BY_DELIVERY_ORDER_ID = `${config.spring_url_base}delivery_order/find_receiver_phone`;
const GET_LOGS_BY_DELIVERY_ORDER_ID = `${config.spring_url_base}delivery_order/log`;
const GET_ORIGINAL_ID = `${config.spring_url_base}delivery_order/get_original_id`;
const SCAN_BY_BARCODE = `${config.spring_url_base}delivery_order/sheet/scan_barcode`;
const GET_LAST_20_ORDERS = `${config.spring_url_base}delivery_order/barcodes`;
const GET_INVENTORY_LAST_10_ORDERS = `${config.spring_url_base}inventory/barcodes`;

const GET_DELIVERY_SHEET = `${config.spring_url_base}delivery_sheet`;

const GET_ALL_DRIVER = `${config.spring_url_base}driver/for_selector`;
const GET_ALL_ACTIVE_DRIVER = `${config.spring_url_base}driver/active/list`;
const GET_ALL_DRIVER_ROUTES = `${config.spring_url_base}driver/routes`;
const GET_DRIVER_PIN_LOCATIONS = `${config.spring_url_base}driver/location/pin`;

const DELETE_DELIVERY_ORDER = `${config.spring_url_base}delivery_order/delete_by_id`;
const DELETE_SHEET_BY_ID = `${config.spring_url_base}delivery_sheet/delete_by_id`;
const DELETE_SHEET_ITEM = `${config.spring_url_base}delivery_sheet/remove_item`;
const ADD_ITEM_TO_SHEET = `${config.spring_url_base}delivery_sheet/add_item`;

const UPDATE_SHEET_EXPRA_EXPEND = `${config.spring_url_base}delivery_sheet/update_expend`;
const GET_DELIVERY_SHEET_DETAIL = `${config.spring_url_base}delivery_sheet/detail`;

const GET_INVOICE = `${config.spring_url_base}invoice`;
const GET_INVOICE_DETAIL = `${config.spring_url_base}invoice/detail`;
const GET_INVOICE_DETAIL_BY_DELIVERY_ORDER = `${config.spring_url_base}invoice/detail_by_delivery_order`;

const UPDATE_PAID_INVOICE = `${config.spring_url_base}invoice/update_paid`;
const UPDATE_INVOICE_STATUS = `${config.spring_url_base}invoice/update_status`;
const UPDATE_INVOICE_NUMBER = `${config.spring_url_base}invoice/update_number`;

const GET_INVOICE_ORDER_DELIVERED = `${config.spring_url_base}invoice/delivered`;
const GET_MERCHANT_FOR_INVOICE = `${config.spring_url_base}merchant/invoice_selector`;
const GET_DELIVERED_DATE_RANG = `${config.spring_url_base}invoice/rang_delivered_date`;
const UPDATE_DELIVERED_ZONE = `${config.spring_url_base}invoice/change_delivered_zone`;
const CREATE_INVOICE = `${config.spring_url_base}invoice/create`;
const MARK_OUT_FOR_DELIVERY = `${config.spring_url_base}delivery_sheet/mark_out_for_delivery`;
const DELETE_INVOICE = `${config.spring_url_base}invoice/delete`;
const GET_INVOICE_SCHEDULE_BY_DAY = `${config.spring_url_base}invoice/schedule_by_day`;
const UPDATE_INVOICE_PDF_URL = `${config.spring_url_base}invoice/update_pdf_url`;

const GET_ALL_DRIVERS = `${config.spring_url_base}driver`;
const UPDATE_DRIVER = `${config.spring_url_base}driver`;
const UPDATE_DRIVER_ONLINE_STATUS = `${config.spring_url_base}driver/online/status/update`;
const CREATE_DRIVER = `${config.spring_url_base}driver`;
const GET_DRIVE_DETAIL_BY_ID = `${config.spring_url_base}driver/by_id`;

const GET_DRIVER_PICKUP_MERCHANT_LIST = `${config.spring_url_base}driver/pickup/merchant/list`;
const CREATE_DRIVER_PICKUP_MERCHANT = `${config.spring_url_base}driver/pickup/merchant/create`;
const DELETE_DRIVER_PICKUP_MERCHANT = `${config.spring_url_base}driver/pickup/merchant/delete`;

const GET_KPI_STATISTIC = `${config.spring_url_base}kpi/statistic`;

const GET_KPI_1 = `${config.spring_url_base}kpi/kpi_1_lite`;
const GET_KPI_2 = `${config.spring_url_base}kpi/kpi_2_lite`;
const GET_KPI_3 = `${config.spring_url_base}kpi/kpi_3_lite`;
const GET_KPI_SHOP = `${config.spring_url_base}kpi/kpi_shop`;
const GET_KPI_PROVINCE = `${config.spring_url_base}kpi/kpi_province`;
const GET_KPI_INVENTORY = `${config.spring_url_base}kpi/kpi_inventory`;
const GET_KPI_DELIVERED_BY_SENDER = `${config.spring_url_base}kpi/delivered_by_sender`;
const GET_KPI_DRIVER_BY_DRIVER = `${config.spring_url_base}kpi/kpi_driver`;
const GET_PINNED_LOCATION = `${config.spring_url_base}kpi/pinned_location`;
const GET_KPI_DELIVERED_BY_DRIVER = `${config.spring_url_base}kpi/delivered_by_driver`;
const GET_KPI_DELIVERED_BY_YEAR = `${config.spring_url_base}kpi/delivered_by_year`;
const GET_KPI_DELIVERED_BY_MONTH = `${config.spring_url_base}kpi/delivered_by_month`;
const GET_KPI_DELIVERED_BY_WEEKLY = `${config.spring_url_base}kpi/delivered_by_weekly`;
const GET_KPI_DELIVERED_BY_PROVINCE = `${config.spring_url_base}kpi/delivered_by_province`;
const GET_KPI_DELIVERED_FAILED = `${config.spring_url_base}kpi/delivered_failed`;
const GET_KPI_DAILY_PICKUP_TRACKING = `${config.spring_url_base}kpi/daily_pickup_tracking`;
const GET_MONTHLY_TOTAL_PICKUP = `${config.spring_url_base}kpi/monthly_total_pickup_tracking`;

const GET_KPI_DAILY_COUNT_BY_STATUS = `${config.spring_url_base}kpi/daily_count_by_status`;
const GET_KPI_MONTHLY_PICKUP_TRACKING = `${config.spring_url_base}kpi/monthly_pickup_tracking`;
const GET_KPI_DAILY_PACKAGE_TRACKING = `${config.spring_url_base}kpi/daily_package_tracking`;


const GET_SENDER_LIST = `${config.spring_url_base}merchant`;
const GET_SENDER_DETAIL = `${config.spring_url_base}merchant/detail_by_id`;
const GET_SENDERS_BY_NAME = `${config.spring_url_base}merchant/by_name`;

const CREATE_MERCHANT = `${config.spring_url_base}merchant/create`;
const CREATE_MERCHANT_PHONE = `${config.spring_url_base}merchant/create_phone`;
const CREATE_MERCHANT_ADDRESS = `${config.spring_url_base}merchant/create_address`;
const UPDATE_MERCHANT_ADDRESS = `${config.spring_url_base}merchant/address/update`;

const UPDATE_MERCHANT = `${config.spring_url_base}merchant/update`;
const UPDATE_MERCHANT_SCHEDULE = `${config.spring_url_base}merchant/update_schedule`;

const GET_ALL_MERCHANT_PHONE = `${config.spring_url_base}merchant/phones`;
const GET_MERCHANT_PHONE = `${config.spring_url_base}merchant/phones_by_sender_id`;
const UPDATE_MERCHANT_PHONE = `${config.spring_url_base}merchant/phone/update`;
const DELETE_MERCHANT_PHONE = `${config.spring_url_base}merchant/phone/delete`;
const DELETE_MERCHANT = `${config.spring_url_base}merchant/delete/by_id`;

const GET_SENDER_ADDRESS_BY_SENDER_ID = `${config.spring_url_base}merchant/addresses_by_sender_id`;
const GET_SENDER_ADDRESS_BY_ID = `${config.spring_url_base}merchant/addresses_by_id`;
const DELETE_SENDER_ADDRESS = `${config.spring_url_base}merchant/address`;

const GET_PACKAGE_REQUEST = `${config.spring_url_base}package_request`;
const CREATE_PACKAGE_REQUEST = `${config.spring_url_base}package_request/request`;

const DELETE_PACKAGE_REQUEST = `${config.spring_url_base}package_request/delete`;
const GET_PACKAGE_REQUEST_DETAIL = `${config.spring_url_base}package_request/by_id`;
const PACKAGE_REQUEST_CONFIRM_PICK = `${config.spring_url_base}package_request/confirm_pick`;
const PACKAGE_REQUEST_CONFIRM_PACK = `${config.spring_url_base}package_request/confirm_pack`;
const REQUEST_EDIT_PACKAGE_REQUEST = `${config.spring_url_base}package_request/request_edit`;
const PACKAGE_REQUEST_CONFIRM_PICKS = `${config.spring_url_base}package_request/confirm_picks`;

const GET_PICKUP_REQUESTS = `${config.spring_url_base}pickup_request/list`;
const UPDATE_PICKUP_REQUESTS = `${config.spring_url_base}pickup_request/update`;
const GET_PICKUP_LOCATION = `${config.spring_url_base}pickup_request/locations`;
const GET_ALL_MERCHANT_LOCATIONS = `${config.spring_url_base}merchant/locations`;

const CREATE_PICKUP_REQUEST = `${config.spring_url_base}pickup_request/create`;
const ASSIGN_PICKUP_REQUESTS = `${config.spring_url_base}pickup_request/assign`;
const DELETE_PICKUP_REQUEST = `${config.spring_url_base}pickup_request/delete`;
const GET_PICKUP_AMOUNT = `${config.spring_url_base}pickup_request/amount`;


const GET_RECEIVERS = `${config.spring_url_base}customer`;
const DELETE_RECEIVER_ADDRESS = `${config.spring_url_base}customer/address`;
const UPDATE_RECEIVER_ADDRESS = `${config.spring_url_base}customer/address`;

const GET_INVENTORY = `${config.spring_url_base}inventory`;
const CREATE_INVENTORY = `${config.spring_url_base}inventory/create`;
const GET_INVENTORY_DETAIL = `${config.spring_url_base}inventory/by_id`;
const UPDATE_INVENTORY = `${config.spring_url_base}inventory/update`;
const CREATE_INVENTORY_TRANSACTION = `${config.spring_url_base}inventory/create_transaction`;

const LOGIN = `${config.spring_url_base}oauth/token`;
const GET_USER_INFO = `${config.spring_url_base}auth/me`;
const GET_USER = `${config.spring_url_base}user`;
const GET_ACCESS_LOGS = `${config.spring_url_base}access/list`;
const SET_ACCESS_IP = `${config.spring_url_base}access/set`;
const UPDATE_USER = `${config.spring_url_base}user`;
const CREATE_USER = `${config.spring_url_base}user`;
const GET_ROLE = `${config.spring_url_base}permission/roles`;
const GET_PERMISSION = `${config.spring_url_base}permission/permissions`;

const DEACTIVATE_USE = `${config.spring_url_base}user/deactivate`;
// const GET_USER_INFO = `${config.spring_url_base}auth/me`;

const GET_SETTINGS = `${config.spring_url_base}setting/system`;
const UPDATE_SETTING = `${config.spring_url_base}setting/system/update`;

const SEND_INVOICE_PDF_TO_SENDER = 'https://joonak-telegram-listener.herokuapp.com/sendBill';

// Ticket || Help desk
const GET_TICKETS = `${config.spring_url_base}help_desk/ticket/list`;
const CREATE_TICKET = `${config.spring_url_base}help_desk/ticket/create`;
const UPDATE_TICKET = `${config.spring_url_base}help_desk/ticket/update`;
const GET_REQUESTED_ORDER = `${config.spring_cc_url_base}customer-service/requested-order/list`;
const UPDATE_REQUESTED_ORDER = `${config.spring_cc_url_base}customer-service/requested-order/update`;


const GET_ALL_ACTIVE_USER = `${config.spring_url_base}user/list`;

// Notification
const GET_NOTIFICATION = `${config.spring_url_base}notification/list`;


export {
  LOGIN,
  GET_USER_INFO,
  GET_USER,
  GET_ACCESS_LOGS,
  SET_ACCESS_IP,

  GET_RECEIVERS,
  DELETE_RECEIVER_ADDRESS,
  UPDATE_RECEIVER_ADDRESS,

  CHECK_ORDER_IMPORT_FILE_NAME,
  REQUEST_EDIT_PACKAGE_REQUEST,
  PACKAGE_REQUEST_CONFIRM_PICK,
  PACKAGE_REQUEST_CONFIRM_PICKS,
  PACKAGE_REQUEST_CONFIRM_PACK,
  GET_PACKAGE_REQUEST_DETAIL,
  DELETE_PACKAGE_REQUEST,
  GET_PACKAGE_REQUEST,
  CREATE_PACKAGE_REQUEST,

  GET_PICKUP_REQUESTS,
  UPDATE_PICKUP_REQUESTS,
  GET_PICKUP_LOCATION,
  GET_ALL_MERCHANT_LOCATIONS,
  DELETE_PICKUP_REQUEST,
  GET_PICKUP_AMOUNT,

  ASSIGN_PICKUP_REQUESTS,
  CREATE_PICKUP_REQUEST,

  DELETE_MERCHANT,
  UPDATE_MERCHANT,
  UPDATE_MERCHANT_SCHEDULE,
  CREATE_MERCHANT_ADDRESS,
  UPDATE_MERCHANT_ADDRESS,

  CREATE_MERCHANT_PHONE,
  GET_ALL_MERCHANT_PHONE,
  GET_MERCHANT_PHONE,
  UPDATE_MERCHANT_PHONE,
  DELETE_MERCHANT_PHONE,
  GET_SENDER_ADDRESS_BY_SENDER_ID,
  GET_SENDER_ADDRESS_BY_ID,
  DELETE_SENDER_ADDRESS,

  CREATE_MERCHANT,
  GET_SENDER_LIST,
  GET_SENDER_DETAIL,
  GET_ALL_DRIVERS,
  UPDATE_DRIVER,
  UPDATE_DRIVER_ONLINE_STATUS,
  CREATE_DRIVER,
  GET_DRIVE_DETAIL_BY_ID,

  GET_DRIVER_PICKUP_MERCHANT_LIST,
  CREATE_DRIVER_PICKUP_MERCHANT,
  DELETE_DRIVER_PICKUP_MERCHANT,

  GET_KPI_STATISTIC,
  GET_KPI_1,
  GET_KPI_2,
  GET_KPI_3,
  GET_KPI_SHOP,
  GET_KPI_PROVINCE,
  GET_KPI_INVENTORY,
  GET_KPI_DELIVERED_BY_SENDER,
  GET_KPI_DRIVER_BY_DRIVER,
  GET_KPI_DELIVERED_BY_DRIVER,
  GET_KPI_DELIVERED_BY_YEAR,
  GET_KPI_DELIVERED_BY_MONTH,
  GET_KPI_DELIVERED_BY_WEEKLY,
  GET_KPI_DELIVERED_BY_PROVINCE,
  GET_KPI_DELIVERED_FAILED,
  GET_KPI_DAILY_PICKUP_TRACKING,
  GET_MONTHLY_TOTAL_PICKUP,
  GET_KPI_DAILY_COUNT_BY_STATUS,
  GET_KPI_MONTHLY_PICKUP_TRACKING,
  GET_KPI_DAILY_PACKAGE_TRACKING,

  GET_PINNED_LOCATION,
  GET_SENDERS,
  GET_SENDERS_BY_NAME,
  GET_SENDERS_USING_INVENTORY,
  GET_SENDERS_FOR_INVOICE,
  GET_INVOICE,
  UPDATE_PAID_INVOICE,
  UPDATE_INVOICE_STATUS,
  UPDATE_INVOICE_NUMBER,
  GET_INVOICE_ORDER_DELIVERED,
  GET_MERCHANT_FOR_INVOICE,
  GET_DELIVERED_DATE_RANG,
  UPDATE_DELIVERED_ZONE,
  CREATE_INVOICE,
  GET_INVOICE_DETAIL,
  GET_INVOICE_DETAIL_BY_DELIVERY_ORDER,

  MARK_OUT_FOR_DELIVERY,
  DELETE_INVOICE,
  UPDATE_INVOICE_PDF_URL,
  GET_INVOICE_SCHEDULE_BY_DAY,
  GET_RECEIVER_PHONE_LIKE,
  GET_RECEIVER_PHONE_ID,
  GET_OR_CREATE_CUSTOMER_PHONE,
  GET_RECEIVER_PHONE_BY_VALUE,
  GET_RECEIVER_PHONE_BY_RECEIVER,
  GET_RECEIVER_ADDRESS_BY_RECEIVER,
  CREATE_RECEIVER_BY_PHONE,
  CREATE_RECEIVER_ADDRESS,
  UPDATE_RECEIVER_NAME,
  GET_RECYCLE_LOG_BY_DELIVERYORDER,
  CREATE_RECYCLE_LOG,
  CREATE_DELIVERY_SHEET,
  DELETE_DELIVERY_SHEET,
  GET_DELIVERYORDER_PACKAGE_REQUEST,
  GET_DELIVERYORDER_BY_ID,
  UPDATE_DELIVERYORDER,
  CREATE_DELIVERYORDER,
  GET_INVENTORY_BY_SENDER,
  GET_SHEET_BY_DELIVERY_ORDER_ID,
  GET_RECEIVER_PHONE_BY_DELIVERY_ORDER_ID,
  GET_LOGS_BY_DELIVERY_ORDER_ID,

  CREATE_PACKAGE_REQUEST_BY_ORDER,
  ADD_ITEM_INTO_PACKAGE_REQUEST,
  DELETE_PACKAGE_REQUEST_ITEM,
  ADJUST_PACKAGE_REQUEST_QTY,
  GET_ORIGINAL_ID,
  GET_DELIVERY_ORDER,
  GET_DELIVERY_ORDER_LIST,
  GET_DELIVERY_4_EXPORT_STATUS,
  SCAN_BY_BARCODE,
  GET_LAST_20_ORDERS,
  GET_INVENTORY_LAST_10_ORDERS,

  GET_ALL_DRIVER,
  GET_ALL_ACTIVE_DRIVER,
  GET_ALL_DRIVER_ROUTES,
  GET_DRIVER_PIN_LOCATIONS,
  GET_DELIVERY_SHEET,
  DELETE_DELIVERY_ORDER,
  DELETE_SHEET_BY_ID,
  DELETE_SHEET_ITEM,
  GET_DELIVERY_SHEET_DETAIL,
  UPDATE_SHEET_EXPRA_EXPEND,
  CONFIRM_DELIVERY_SHEET,
  CONFIRM_DELIVERY_SHEET_BATCH,

  REASSIGN_SHEET,
  ADD_ITEM_TO_SHEET,
  GET_PROVINCES,
  GET_INVENTORY,
  GET_INVENTORY_DETAIL,
  CREATE_INVENTORY,
  UPDATE_INVENTORY,
  CREATE_INVENTORY_TRANSACTION,
  GET_ROLE,
  GET_PERMISSION,
  DEACTIVATE_USE,
  UPDATE_USER,
  CREATE_USER,

  SEND_INVOICE_PDF_TO_SENDER,

  UPDATE_SETTING,
  GET_SETTINGS,

  // Ticket || HelpDesk
  GET_TICKETS,
  CREATE_TICKET,
  UPDATE_TICKET,
  GET_REQUESTED_ORDER,
  UPDATE_REQUESTED_ORDER,

  GET_ALL_ACTIVE_USER,

  // Notification
  GET_NOTIFICATION,
};
